import { PublishersTable } from './publishers-table';

export { PublishersTable };
